import * as React from "react";
const SvgGoogleCampaignManager360 = (props, ref) => (
  <svg
    width="1em"
    height="1em"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    {...{ ...props, ref }}
  >
    <path
      d="M16.594 29.246c-1.471 1.473-4.002 1.622-5.635-.013l-5.942 5.95c4.85 4.855 12.707 4.853 17.556 0s4.849-12.724 0-17.579l-5.969 5.977c1.617 1.616 1.515 4.138-.01 5.665z"
      fill="#34a853"
    />
    <path
      d="M28.224 17.6c-1.504 1.507-4.04 1.618-5.651.004l-5.958 5.966c4.849 4.855 12.706 4.853 17.555 0s4.849-12.723 0-17.578l-5.95 5.957c1.637 1.641 1.482 4.172.005 5.651z"
      fill="#5bb974"
    />
    <path
      d="M34.17 5.994c-4.849-4.855-12.706-4.853-17.555 0-4.847 4.853-4.849 12.723 0 17.578l5.958-5.966c-1.66-1.662-1.47-4.181.008-5.66 1.587-1.59 4.116-1.518 5.64.007a4.203 4.203 0 0 0 5.95 0 4.219 4.219 0 0 0 0-5.96z"
      fill="#1e8e3e"
    />
    <path
      d="M22.573 17.606c-4.849-4.855-12.707-4.853-17.556 0-4.846 4.853-4.846 12.724 0 17.577a4.51 4.51 0 0 0 6.385 0c1.763-1.766 1.318-4.188-.445-5.954-1.42-1.421-1.703-3.941-.008-5.64 1.38-1.382 3.85-1.776 5.655-.01 1.764 1.765 4.415 1.564 5.99-.011 1.518-1.517 1.742-4.198-.021-5.962z"
      fill="#5bb974"
    />
  </svg>
);
export default React.forwardRef(SvgGoogleCampaignManager360);
